import { useNavigate } from 'react-router-dom';
import './StudyCard.css';

const StudyCard = ({ study }) => {
  const navigate = useNavigate();

  const {
    id,
    title,
    description,
    template,
    tags = [],
    entry_count = 0,
    latest_entry_date,
  } = study;

  const handleClick = () => navigate(`/studies/${id}`);

  return (
    <div className="study-card" onClick={handleClick} role="button" tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}>
      <div className="study-card-header">
        <div className="study-card-title">{title}</div>
        {latest_entry_date && (
          <div className="study-card-date">최근 {latest_entry_date}</div>
        )}
      </div>

      {description && (
        <div className="study-card-description">{description}</div>
      )}

      <div className="study-card-footer">
        <div className="study-card-meta">
          {template && (
            <span className="study-card-template">
              {template.name}
              {template.version && ` v${template.version}`}
            </span>
          )}
          {tags.length > 0 && (
            <div className="study-card-tags">
              {tags.map((tag, i) => (
                <span key={i} className="study-card-tag">#{tag}</span>
              ))}
            </div>
          )}
        </div>
        <div className="study-card-entry-count">
          📝 엔트리 {entry_count}
        </div>
      </div>
    </div>
  );
};

export default StudyCard;
